import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as eventService from '../../../services/eventService'
import * as marketService from '../../../services/marketService'
class EventControlForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventData: {}
    };
  }
  componentDidMount() {
    this.loadEventData()
  }
  loadEventData() {
    let eventId = this.props.eventId
    eventService.getFullEvent(eventId).then((res) => {
      let evetData = res
      if (!!evetData) {
        Array.prototype.forEach.call(evetData.catalogues,(market, i) => {
          let mktCond = evetData.marketConditions.filter((cond, i) => {
            return cond.marketId === market.marketId
          })[0]
          evetData.catalogues[i] = { ...mktCond, ...market }
          let mktBook = evetData.metadata.books.filter((book) => {
            return market.marketId === (!!book ? book.marketId : "")
          })
          evetData.catalogues[i].metadata = {}
          evetData.catalogues[i].metadata.book = mktBook.length > 0 ? mktBook[0] : {}
        })
      }
      this.setState({ eventData: evetData })
    })
  }
  changeEvent(field, value, marketIndex) {
    let eventData = this.state.eventData
    if (field === "tvUrl") {
      eventData[field] = value
    } else {
      eventData.catalogues[marketIndex][field] = value
    }
    this.setState({ eventData: eventData })
  }
  updateTvUrl() {
    let body = {
      "eventId": this.props.eventId,
      "tvUrl": this.state.eventData.tvUrl
    }
    eventService.updateTvUrl(body).then((res) => {
      if (res.isSuccess) {
        alert("TV URL Successfully Updated!")
      }
    })
  }
  changeMarketActiveStatus(marketId, activate) {
    let body = {
      "marketId": marketId,
      "eventId": this.props.eventId,
      "competitionId": this.props.competitionId,
      "eventTypeId": this.props.isAdmin ? this.props.eventTypeId : this.props.eventTypeId.toString()
    }
    if (activate) {
      marketService.activateMarket(body).then((res) => {
        if (res.isSuccess) {
          this.loadEventData()
        }
      })
    } else {
      marketService.deActivateMarket(body).then((res) => {
        if (res.isSuccess) {
          this.loadEventData()
        }
      })
    }
  }
  updateMarket(marketIndex) {
    let market = this.state.eventData.catalogues[marketIndex]
    let body = {
      "marketId": market.marketId,
      "eventId": this.props.eventId,
      "competitionId": this.props.competitionId,
      "eventTypeId": this.props.isAdmin ? this.props.eventTypeId : this.props.eventTypeId.toString(),
      "minBet": parseFloat(market.minBet),
      "maxBet": parseFloat(market.maxBet)
    }
    if (this.props.isAdmin) {
      body.mtp = parseFloat(market.mtp);
      body.potLimit = parseFloat(market.potLimit);
    }
    marketService.updateMarket(body).then((res) => {
      if (res.isSuccess) {
        alert("Market Successfully Updated!")
      }
    })

  }
  changeBetActiveStatus(marketId, activate) {
    let body = {
      "marketId": marketId,
      "eventId": this.props.eventId,
      "competitionId": this.props.competitionId,
      "eventTypeId": this.props.isAdmin ? this.props.eventTypeId : this.props.eventTypeId.toString()
    }
    if (activate) {
      marketService.activateMarketBet(body).then((res) => {
        if (res.isSuccess) {
          this.loadEventData()
        }
      })
    } else {
      marketService.deActivateMarketBet(body).then((res) => {
        if (res.isSuccess) {
          this.loadEventData()
        }
      })
    }
  }
  render() {
    console.log(this.state.eventData)
    return (
      <>
        <div className="modal fade show" id="myedit" role="dialog" style={{ "display": "block", overflow: "auto" }} aria-hidden="true">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">{!!this.state.eventData.event ? this.state.eventData.event.name : ""}</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={() => { this.props.closeForm() }}>×</button>
              </div>
              <div className="modal-body table-responsive event-con-popup1">
                <table id="Table1" className="table mb-none nowrap table-sm w-100 font-12 event-con-popup ">
                  <tbody>
                    {this.state.eventData.catalogues && this.state.eventData.catalogues.length > 0 && this.state.eventData.catalogues.map((mkt, i) => {
                      return (
                        <tr className="bor-bot-1">
                          <td>
                            <span className="mr-3 t-match wid200">{!!mkt.marketName ? mkt.marketName : mkt.marketType.replace("_", " ")}</span>
                            <span className="mr-2">Active</span>
                            <span>
                              <label className="checkboxx">
                                <input type="checkbox" checked={this.state.eventData.metadata.inactiveMarkets.indexOf(mkt.marketId) === -1} onChange={() => { this.changeMarketActiveStatus(mkt.marketId, !(this.state.eventData.metadata.inactiveMarkets.indexOf(mkt.marketId) === -1)) }} />
                                <span className="checkmark1 mt-6"></span>
                              </label>
                            </span>
                            <span className="mr-1">Betlock</span>
                            <span>
                              <label className="checkboxx">
                                <input type="checkbox" checked={mkt.betLock} onChange={() => { this.changeBetActiveStatus(mkt.marketId, !mkt.betLock) }} />
                                <span className="checkmark1 mt-6"></span>
                              </label>
                            </span>
                            <span className="mr-1">Min</span>
                            <span className="mr-2">
                              <input type="number" onChange={(e) => { this.changeEvent("minBet", e.target.value, i) }} value={mkt.minBet} className="form-control d-inline w-25" placeholder="2" />
                            </span>
                            <span className="mr-1">Max</span>
                            <span className="mr-2">
                              <input type="number" onChange={(e) => { this.changeEvent("maxBet", e.target.value, i) }} value={mkt.maxBet} className="form-control d-inline w-25" placeholder="2" />
                            </span>
                            <span className="mr-1">MTP</span>
                            <span className="mr-2">
                              <input type="number" onChange={(e) => { this.changeEvent("mtp", e.target.value, i) }} value={mkt.mtp} disabled={true} className="form-control d-inline w-25" />
                            </span>
                            <span className="mr-1">Pot:</span>
                            <span className="mr-2">
                              <input type="number" onChange={(e) => { this.changeEvent("potLimit", e.target.value, i) }} value={mkt.potLimit} disabled={true} className="form-control d-inline w-25" placeholder="4.00" />
                            </span>
                            <button className="update-btn" onClick={() => { this.updateMarket(i) }}>Update</button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={() => { this.props.closeForm() }}></div>
        </div>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EventControlForm);